import React from "react";
import { ProductConsumer } from "../../../../Context/AddProWakel";
const SecondRow = () => {
  return (
    <>
      <ProductConsumer>
        {(value) => {
          const {
            AddProChange,
            R_del_dis,
            R_anotherInputWakil,
            R_frosth,
            R_joripara,
            R_mob,
            R_nawe_barez,
            R_zh_barez,
            R_search_wakil,
            toanotherInput,
            R_wargr,
            R_toAnotherRow,
            R_toThirdRow
          } = value;
          return (
            <>
              <form>
                <div className="row">
                  <div className="col-4 text-right mt-2">
                    <div className="form-group">
                      <label className="font-weight-bold f4">بەڕێز</label>
                      <input
                        type="text"
                        disabled={R_del_dis == true ? true : null}
                        value={R_nawe_barez}
                        name="R_nawe_barez"
                        onKeyPress={(event) =>
                          event.key == "Enter" ? R_toAnotherRow(event) : null
                        }
                        onChange={AddProChange}
                        className={`form-control text-right font-weight-bold ${
                          R_frosth == "فرۆشتنی وەکیل"
                            ? "bg-success text-white"
                            : `${
                                R_frosth == "فرۆشتنی ڕاستەوخۆ"
                                  ? "bg-danger text-white"
                                  : ""
                              }`
                        }`}
                      />
                    </div>
                  </div>

                  <div className="col-4 text-right mt-2">
                    <div className="form-group">
                      <label className="font-weight-bold f4">کۆد.وەکیل</label>
                      <input
                        type="text"
                        value={R_zh_barez > 0 ? R_zh_barez : ""}
                        disabled={
                          R_search_wakil == true ||
                          R_frosth == "فرۆشتنی ڕاستەوخۆ" ||
                          R_frosth == null ||
                          R_del_dis == true
                            ? true
                            : null
                        }
                        name="R_zh_barez"
                        onKeyPress={(event) =>
                          event.key == "Enter"
                            ? R_anotherInputWakil(event)
                            : null
                        }
                        onChange={AddProChange}
                        className={`form-control text-right font-weight-bold  ${
                          R_frosth == "فرۆشتنی وەکیل"
                            ? "bg-success text-white"
                            : `${R_frosth == "فرۆشتنی ڕاستەوخۆ" ? "" : ""}`
                        }`}
                      />
                    </div>
                  </div>
                  <div className="col-sm-4 text-right mt-2">
                    <label className="font-weight-bold f4">جۆری فرۆشتن</label>
                    <select
                      disabled={R_del_dis == true ? true : null}
                      className={`form-control text-right font-weight-bold selectpicker pull-right ${
                        R_frosth == "فرۆشتنی وەکیل"
                          ? "bg-success text-white"
                          : `${
                              R_frosth == "فرۆشتنی ڕاستەوخۆ"
                                ? "bg-danger text-white"
                                : ""
                            }`
                      }`}
                      onChange={AddProChange}
                      onKeyPress={(event) =>
                        event.key == "Enter" ? toanotherInput(event) : null
                      }
                      name="R_frosth"
                      value={R_frosth != null ? R_frosth : ""}
                    >
                      <option className="ml5">جۆری فرۆشتن</option>
                      <option> فرۆشتنی وەکیل</option>
                      <option> فرۆشتنی ڕاستەوخۆ</option>
                    </select>
                  </div>
                </div>
                {/*seconnd row  */}
                <div className="row card-header p-1 border-bottom border-warning">
                  <div className="col-4 text-right">
                    <label className="font-weight-bold f4">ناوی وەرگر</label>
                    <select
                      disabled={R_del_dis == true ? true : null}
                      className={`form-control text-right font-weight-bold selectpicker pull-right ${
                        R_wargr == "یوسف"
                          ? "bg-success text-white"
                          : `${
                              R_wargr == "یوسف"
                                ? "bg-danger text-white"
                                : ""
                            }`
                      }`}
                      onChange={AddProChange}
                      name="R_wargr"
                      value={R_wargr != null ? R_wargr : ""}
                    >
                      <option className="ml5">ناوی وەرگر</option>
                      <option>یوسف</option>
                      <option>یوسف</option>
                    </select>
                  </div>
                  <div className="col-sm-4 text-right">
                    <label className="font-weight-bold f4">جۆری دراو</label>
                    <select
                      className={`form-control text-right font-weight-bold selectpicker pull-right ${
                        R_joripara == "دۆلار"
                          ? "bg-success text-white"
                          : `${
                              R_joripara == "دینار"
                                ? "bg-danger text-white"
                                : ""
                            }`
                      }`}
                      onChange={AddProChange}
                      onKeyPress={(event) =>
                        event.key == "Enter" ? toanotherInput(event) : null
                      }
                      name="R_joripara"
                      value={R_joripara != null ? R_joripara : ""}
                    >
                      <option
                        className="ml5"
                        disabled={R_joripara != null ? true : null}
                      >
                        جۆری دراو
                      </option>
                      <option disabled={R_joripara == "دینار" ? true : null}>
                        دۆلار
                      </option>
                      <option disabled={R_joripara == "دۆلار" ? true : null}>
                        دینار
                      </option>
                    </select>
                  </div>
                  <div className="col-sm-4 text-right ">
                    <div className="form-group">
                      <label className="font-weight-bold f4">تەلەفۆن</label>
                      <input
                        type="number"
                        disabled={R_del_dis == true ? true : null}
                        value={R_mob}
                        name="R_mob"
                        onChange={AddProChange}
                        onKeyPress={(event) =>
                          event.key == "Enter" ? toanotherInput(event) : null
                        }
                        className={`form-control text-right font-weight-bold ${
                          R_frosth == "فرۆشتنی وەکیل"
                            ? "bg-success text-white"
                            : `${
                                R_frosth == "فرۆشتنی ڕاستەوخۆ"
                                  ? "bg-danger text-white"
                                  : ""
                              }`
                        }`}
                      />
                    </div>
                  </div>
                </div>
              </form>
            </>
          );
        }}
      </ProductConsumer>
    </>
  );
};

export default SecondRow;
